import 'sharedreact/data/RegisterClasses';

import ClassFactory from 'sharedreact/utils/ClassFactory';

import Customer from 'workspaces/common/data/Customer';
import OrderMaterial from 'workspaces/common/data/OrderMaterial';
import SmartView from 'workspaces/common/data/SmartView';
import ToDo from 'workspaces/common/data/ToDo';
import ToDoParameter from 'workspaces/common/data/ToDoParameter';

function _registerClasses () {
  ClassFactory.registerClassWithName('Customer', Customer);
  ClassFactory.registerClassWithName('OrderMaterial', OrderMaterial);
  ClassFactory.registerClassWithName('SmartView', SmartView);
  ClassFactory.registerClassWithName('ToDo', ToDo);
  ClassFactory.registerClassWithName('ToDoParameter', ToDoParameter);
}

class RegisterClasses {
  constructor () {
    _registerClasses();
  }
}

export default new RegisterClasses();